import styled from 'styled-components';
import { colors } from '~/styles';
import { Icon } from '~/components';
import React from 'react';

const ActionsSuccess = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.white};
  background-color: ${colors.success};
  margin-top: -1px;
  margin-bottom: -1px;
  margin-right: -1px;

  .icon {
    font-size: 0.75rem;
  }
`;

const ListViewActionsSuccess = () => (
  <ActionsSuccess>
    <Icon icon="check" />
  </ActionsSuccess>
);

export default ListViewActionsSuccess;
